<template>
  <div class="page-container">
    <div class="page-header">
      <div class="page-title">
        로거 상세
        <span class="count-text">{{ form.loggerName || '-' }}</span>
      </div>

      <div class="header-buttons">
        <button class="btn ghost" @click="$emit('back')">목록으로</button>
        <button class="btn primary" @click="saveLogger">저장</button>
      </div>
    </div>

    <div class="content-wrapper">
      <div class="detail-card">

        <div class="form-row">
          <label class="form-label">로거명</label>
          <input
            v-model="form.loggerName"
            class="control"
            type="text"
            placeholder="로거명을 입력하세요"
          />
        </div>

        <div class="form-row">
          <label class="form-label">연동된 현장</label>
          <select v-model="form.siteId" class="control">
            <option :value="null">현장 설정 안함</option>
            <option
              v-for="site in siteOptions"
              :key="site.id"
              :value="Number(site.id)"
            >
              {{ site.name }}
            </option>
          </select>
        </div>

        <div class="form-row">
          <label class="form-label">시리얼번호</label>
          <input
            v-model="form.serialNumber"
            class="control"
            type="text"
            placeholder="시리얼번호를 입력하세요"
          />
        </div>

        <div class="form-row">
          <label class="form-label">라인번호</label>
          <input
            :value="form.lineNumber"
            class="control"
            type="text"
            readonly
          />
        </div>

        <div class="form-row">
          <label class="form-label">설명</label>
          <textarea
            v-model="form.explain"
            class="control"
            placeholder="설명을 입력하세요"
          ></textarea>
        </div>

        <div class="form-row">
          <label class="form-label">등록방식</label>
          <input
            :value="form.registerType || '-'"
            class="control"
            type="text"
            readonly
          />
        </div>

        <div class="form-row">
          <label class="form-label">생성일</label>
          <input
            :value="formatDateTime(form.createdAt)"
            class="control"
            type="text"
            readonly
          />
        </div>

        <div class="form-row">
          <label class="form-label">수정일</label>
          <input
            :value="formatDateTime(form.updatedAt)"
            class="control"
            type="text"
            readonly
          />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/axios'

export default {
  name: 'LoggerDetail',

  props: {
    loggerId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      siteOptions: [],
      form: {
        id: null,
        siteId: null,
        loggerName: '',
        serialNumber: '',
        lineNumber: '',
        explain: '',
        registerType: '',
        createdAt: '',
        updatedAt: '',
      },
    }
  },

  mounted() {
    this.initPage()
  },

  watch: {
    loggerId(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.initPage()
      }
    },
  },

  methods: {
    async initPage() {
      this.loading = true
      try {
        await this.fetchSiteOptions()
        await this.fetchDetail()
      } finally {
        this.loading = false
      }
    },

    async fetchSiteOptions() {
      try {
        const response = await api.get('/app/site/list', {
          params: {
            deleted: false,
            orderBy: 'siteNameAsc',
          },
        })

        const result = response.data

        if (Array.isArray(result?.result)) {
          this.siteOptions = result.result
        } else {
          this.siteOptions = result?.result?.content || []
        }

      } catch (error) {
        console.error('현장 목록 조회 실패', error)
        this.siteOptions = []
      }
    },

    async fetchDetail() {
      try {
        const response = await api.get('/app/sensorLogger/detail', {
          params: { id: this.loggerId },
        })

        const result = response.data
        const detail = result?.result

        if (!detail) {
          alert('로거 상세 데이터가 없습니다.')
          return
        }

        this.form = {
          id: detail?.id ?? null,
          siteId: detail?.siteId ? Number(detail.siteId) : null,
          loggerName: detail?.loggerName ?? '',
          serialNumber: detail?.serialNumber ?? '',
          lineNumber: detail?.lineNumber ?? '',
          explain: detail?.explain ?? '',
          registerType: detail?.registerType ?? '',
          createdAt: detail?.createdAt ?? '',
          updatedAt: detail?.updatedAt ?? '',
        }
      } catch (error) {
        console.error('로거 상세 조회 실패', error)
        alert('로거 상세 조회에 실패했습니다.')
      }
    },

    async saveLogger() {
      try {
        await api.post('/app/sensorLogger/update', {
          id: this.form.id,
          siteId: this.form.siteId === '' ? null : this.form.siteId,
          loggerName: this.form.loggerName,
          serialNumber: this.form.serialNumber,
          lineNumber: this.form.lineNumber ? Number(this.form.lineNumber) : null,
          explain: this.form.explain,
        })

        alert('저장되었습니다.')
        this.$emit('saved')
      } catch (error) {
        console.error('로거 저장 실패', error)
        alert('저장에 실패했습니다.')
      }
    },

    formatDateTime(value) {
      if (!value) return '-'

      try {
        const date = new Date(value)

        const yyyy = date.getFullYear()
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        const dd = String(date.getDate()).padStart(2, '0')
        const hh = String(date.getHours()).padStart(2, '0')
        const mi = String(date.getMinutes()).padStart(2, '0')
        const ss = String(date.getSeconds()).padStart(2, '0')

        return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`
      } catch (e) {
        return value
      }
    },
  },
}
</script>

<style scoped>
@import "@/styles/admin/admin-layout.css";
@import "@/styles/admin/admin-button.css";
@import "@/styles/admin/admin-input.css";
@import "@/styles/admin/admin-form.css";
@import "@/styles/admin/admin-card.css";
</style>